exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".edit-weight-category .text-right {\n  text-align: right; }\n\n.edit-weight-category .column-titles {\n  -ms-flex-preferred-size: 50%;\n  flex-basis: 50%;\n  font-size: .875rem; }\n\n.edit-weight-category .w-50 {\n  width: 50%; }\n\n.edit-weight-category #weight, .edit-weight-category #price {\n  text-align: right; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/delivery/AddEditWeightCategory/index.scss
// module id = 1555
// module chunks = 0